import React, { Component } from "react";
import TopHeader from './TopHeader';
import { connect } from 'react-redux';

class Header extends Component {

  showCart(e) {
    e.preventDefault();
    let cartContainer = document.getElementById("cart-dropdown");
    cartContainer.classList.add("cart-dropdown--open");
  }

  render() {
    return (
      <header>
        
        <TopHeader />

      </header>
    );
  }
}

const mapStateToProps = state => ({ cart: state.cart });
export default connect(mapStateToProps)(Header);


// WEBPACK FOOTER //
// ./src/Components/Layout/Header.js